/**
 * Imports
 */
import { createSelector } from '@reduxjs/toolkit';

import { VibrantlyState } from 'store/types';

/**
 * Selectors
 */
export const rootSelector = (state: VibrantlyState) => state.merchant;

export const merchantsSelector = createSelector(
  [rootSelector],
  (root) => root.merchants,
);
